import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Spinner } from '../../../Components'
import { useCQuery } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { showToast } from '../../../utils/toast'
import { Form } from './Form'

const language = cap.language.state || 'IT'
const t = translations[language]

export const GigiForm = () => {
  const { conversationId } = useParams()
  const { isSuccess, isError } = useCQuery(['conversation', conversationId])
  const navigate = useNavigate()

  useEffect(() => {
    if (isError) {
      showToast('error', t.errore, t.gfConversazioneNonTrovata)
      navigate('/operatore/list')
    }
  }, [isError])

  if (!isSuccess) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: 200 }}>
        <Spinner />
      </div>
    )
  }
  return <Form />
}
